import { WithRequiredKeys } from '../../../types';
import { PaginatedResult, PaginationParams, serializePagination } from '../../pagination';
import { API_FEEDBACKS_PATH, getClient } from '../api';
import { Feedback } from '../dtos';
import { UpdateProviderFunction } from '../types';
import { serializeParams } from '../utils/serializer';

export interface GetFeedbacksFilters {
  reference?: Feedback['reference'],
  contactId?: Feedback['contactId']
}

export const serializeGetFeedbacksParams = (
  {
    reference,
    ...rest
  }: GetFeedbacksFilters = {},
  pagination: PaginationParams = {},
) => {
  const filters = {
    reference: reference ? `${reference.type}:${reference.id}` : undefined,
    ...rest,
  };

  return {
    ...serializeParams(filters),
    ...serializePagination(pagination),
  };
};

export async function getFeedbacks(
  filters: GetFeedbacksFilters = {},
  pagination: PaginationParams = { size: 50 },
): Promise<PaginatedResult<Feedback>> {
  const client = await getClient();
  const { data } = await client.get<PaginatedResult<Feedback>>(API_FEEDBACKS_PATH, {
    params: serializeGetFeedbacksParams(filters, pagination),
  });
  return data;
}

export const updateFeedback: UpdateProviderFunction<Feedback> = async (feedbackId, feedback) => {
  const client = await getClient();
  const { data } = await client.put<WithRequiredKeys<Feedback, 'id'>>(`${API_FEEDBACKS_PATH}/${feedbackId}`, feedback);
  return data;
};
